module.exports = __webpack_public_path__ + "img/sign_up_page_01.ac7fd0ac.png";